export default {
    IndexSynchronization: {
        Code: '编码',
        Index: '索引',
        Description: '描述',
        New: '新 建',
        type: '来源类型',
        Data: '数据来源',
        add: {
            Basic: '基础信息',
            Data: '数据来源详情',
            Whether: '是否记录到文件',
            Command: '命令文本',
            field: '同步字段',
            name: '字段名称',
            Mapping: '映射字段',
            Operation: '操作',
            code: '请输入编码',
            index: '请输入索引',
            datasource: '请输入数据来源',
            type: '请选择来源类型',
            obtain: '请先输入索引获取映射字段信息！',
            information: '请输入同步字段信息',
        }
    },
};
